import '../common/bn-surface';
import '../common/qr-scanner';
import { LitElement, html } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';

class QrTest extends LitElement {
  static get properties() {
    return {
      error: { type: String },
      message: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles];
  }

  render() {
    return html`
      <h1>QR Test</h1>
      <a href="/organizations">Back to App</a>
      <bn-surface>
        ${this._renderMessage()}
        <qr-scanner @data="${this._parseQr}"></qr-scanner>
      </bn-surface>
    `;
  }

  _renderMessage() {
    if (this.error) {
      return html`<div class="banner banner--critical">${this.error}</div>`;
    }
    if (this.message) {
      return html`<div class="banner banner--success">${this.message}</div>`;
    }
    return html``;
  }

  _parseQr(e) {
    const { data } = e.detail;
    if (!data) {
      return;
    }
    const url = new URL(data);
    if (!url.hostname.includes('binsentry.com')) {
      this.error = 'Unsupported hostname.';
      this.message = '';
      return;
    }
    if (url.pathname.startsWith('/devices/')) {
      const deviceId = url.searchParams.get('deviceId');
      const serialNumber = deviceId.split('/').pop();
      this.message = `Device found: ${serialNumber}`;
    } else if (url.pathname.startsWith('/bins')) {
      const serialNumber = url.searchParams.get('serialNumber');
      this.message = `Bin found: ${serialNumber}`;
    }
  }
}

customElements.define('qr-test', QrTest);
